var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHomePagePriceTag = function SvgHomePagePriceTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 141,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.388 1.74a5 5 0 0 1 6.751.65l10.465 11.706a5 5 0 0 0 4.118 1.652l15.654-1.226a5 5 0 0 1 5.328 4.197l2.475 15.505a4.998 4.998 0 0 0 2.571 3.617l13.831 7.432a5.001 5.001 0 0 1 2.214 6.41l-6.302 14.383a5 5 0 0 0 .208 4.432l7.618 13.73a5 5 0 0 1-1.604 6.59l-13.077 8.692a5.001 5.001 0 0 0-2.221 3.841l-1.015 15.669a5 5 0 0 1-4.912 4.677l-15.7.243a5 5 0 0 0-3.946 2.03l-9.324 12.633a5 5 0 0 1-6.66 1.278l-13.34-8.284a5 5 0 0 0-4.417-.425l-14.674 5.587a5 5 0 0 1-6.294-2.526l-6.743-14.181a5 5 0 0 0-3.486-2.745l-15.365-3.234a5 5 0 0 1-3.93-5.528l1.994-15.575a5 5 0 0 0-1.448-4.194L1.979 77.748a5 5 0 0 1-.317-6.775L11.76 58.95a5 5 0 0 0 1.05-4.311l-3.442-15.32a5 5 0 0 1 3.396-5.871L27.76 28.79a5 5 0 0 0 3.213-3.06l5.388-14.748a5 5 0 0 1 6.031-3.103l15.133 4.19a5 5 0 0 0 4.357-.837L74.388 1.74Z",
    fill: "#620A15"
  })));
};

export default SvgHomePagePriceTag;